import React, { useState } from 'react';

import { useTranslation } from '../../hooks/useTranslation';
import { authFetch } from '../../utils/auth';
import Button from '../common/Button';

const CreateCollectionPopup = ({ onClose, onCollectionCreated }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await authFetch("/collections", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ title, description }),
      });

      if (response.ok) {
        const newCollection = await response.json();
        onCollectionCreated(newCollection);
        onClose();
      } else {
        console.error("Failed to create collection");
      }
    } catch (error) {
      console.error("Error creating collection:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in">
      <div className="bg-background-white shadow-xl p-8 rounded-xl max-w-md w-full mx-4 relative z-60 animate-scale-in border border-border-light">
        <h2 className="text-2xl font-bold mb-4 text-text-primary">{t('createCollectionPopup.title')}</h2>
        <p className="mb-6 text-text-secondary">{t('createCollectionPopup.subtitle')}</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              placeholder={t('createCollectionPopup.namePlaceholder')}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-4 py-2.5 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-200 bg-white text-text-primary"
              required
            />
          </div>
          <div>
            <textarea
              placeholder={t('createCollectionPopup.descriptionPlaceholder')}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full px-4 py-2.5 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-200 bg-white text-text-primary resize-y"
              rows={3}
            />
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <Button variant="outline" className="min-h-[48px]" onClick={onClose}>
              {t('createCollectionPopup.cancel')}
            </Button>
            <Button type="submit" variant="primary" className="min-h-[48px]">
              {t('createCollectionPopup.create')}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCollectionPopup;
